import {AfterViewInit, Component, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {HeatingCheckModel} from '../../../../../../models/data-models/heating-check-model';
import {NgModel} from '@angular/forms';
import {Subscription} from 'rxjs';
import {debounceTime} from "rxjs/operators";
import {ShareService} from "../../../../../../services/share.service";
import {ValidationService} from "../../../../../../services/validation.service";
import {HeatingInformationModel} from '../../../../../../models/data-models/heating-information-model';

@Component({
  selector: 'app-install-heating-check',
  templateUrl: './install-heating-check.component.html',
  styleUrls: ['./install-heating-check.component.scss'],

})
export class InstallHeatingCheckComponent implements AfterViewInit, OnDestroy {
  public model: HeatingCheckModel = new HeatingCheckModel();
  public heatingInfo: HeatingInformationModel = new HeatingInformationModel();

  private readonly modelSub: Subscription;
  private readonly heatingInfoSub: Subscription;
  private inputSubscriptions: Subscription[] = [];

  @ViewChildren(NgModel) inputs: QueryList<NgModel>;

  constructor(
    private shareService: ShareService,
    public validationService: ValidationService
  ) {
    this.model = this.shareService.heatingCheck || new HeatingCheckModel();
    this.modelSub = this.shareService.heatingCheck$.subscribe((data) => {
      this.model = data || new HeatingCheckModel();
    });

    this.heatingInfo = this.shareService.heatingInformation || new HeatingInformationModel();
    this.heatingInfoSub = this.shareService.heatingInformation$.subscribe((data) => {
      this.heatingInfo = data || new HeatingInformationModel();
    });
  }

  ngAfterViewInit(): void {
    this.inputs.forEach(input => {
      this.inputSubscriptions.push(input.control.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(() => {
        this.shareService.heatingCheck = this.model;
      }));
    });

    // Subscribe to changes in the list of inputs
    // (it is called if some input is added or removed from the form/page,
    // for example, because of *ngIf condition changes)
    this.inputs.changes.subscribe(() => {
      // Unsubscribe from old subscriptions
      this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());

      // Subscribe to new inputs
      this.inputs.forEach(input => {
        this.inputSubscriptions.push(input.control.valueChanges.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.shareService.heatingCheck = this.model;
        }));
      });
    });
  }

  ngOnDestroy(): void {
    this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());
    if (this.modelSub) {
      this.modelSub.unsubscribe();
    }
    if (this.heatingInfoSub) {
      this.heatingInfoSub.unsubscribe();
    }
  }

  showError(model: NgModel) {
    return model.control.touched && model.control.invalid
  }

  showAnyError(model: NgModel) {
    return model.control.invalid;
  }

  areChecksOptional(): boolean {
    return this.heatingInfo?.heatings && this.heatingInfo.heatings.length === 1 &&
      this.heatingInfo.heatings[0]?.heatingType === "SUB_DISTRIBUTION" &&
      this.heatingInfo?.heatingControlType === "BOILERS";
  }

}
